import { useEffect, useState } from 'react'
import { useTypedDispatch } from '../../features/reduxhooks/ReduxHooks'
import { HelperConstant } from '../../helpers/HelperConstant';
import { CustomDropdown } from 'components/shared/CustomDropdown';
import * as Yup from "yup";
import { Button, Col, Form, Row } from 'reactstrap';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomPhoneNumberBox } from 'components/shared/CustomPhoneNumberBox';
import { CustomEmailBox } from 'components/shared/CustomEmailBox';
import BrandMasterServices from "../../services/Master.Service"
import { useFormik } from 'formik';
import { findedLocation } from '../../helpers/Helper';
import "./LocationRequestUAE.css"
import { CustomToaster } from 'components/shared/CustomToaster';
import { CustomTextArea } from 'components/shared/CustomTextArea';
import CantFindServicesService from 'services/CantFindLocation.Service';
import { IFindLocation } from 'models/PublicRequest.Model';
import LocationService from 'services/Location.Service';

type Props = {
    direction: string,
    language: "in_en" | "ae_en" | "ae_ar",
    setEditModel?: any,
    Id?: any,
    requestData?: any,
    selectedLocationData: any,
    statusId: any,
    statusList: Array<any>
}

function LocationRequestUAE({ direction, language, setEditModel, Id, requestData, selectedLocationData, statusId, statusList }: Props) {

    let dispatch = useTypedDispatch();
    const pattern = HelperConstant.emailPattern.pattern;

    const [Product, setProduct] = useState<Array<any>>([]);
    const [Brand, setBrand] = useState([]);
    const [StateList, setStateList] = useState<Array<any>>([]);
    const [ProductId, setproductId] = useState<any>('');
    const [showToastUpdate, setShowToastUpdate] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [BrandId, setBrandId] = useState<any>('');
    const [ModelId, setModelId] = useState<any>('');
    const [Model, setModel] = useState([]);
    const [Variant, setVariant] = useState<Array<any>>([]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ProductTypeId: "",
            BrandName: "",
            BrandSeriesName: "",
            BrandModelName: "",
            ModelVariant: "",
            Name: "",
            MobileNumber: "",
            Email: "",
            StateName: "",
            CityName: "",
            Zipcode: "",
            Comments: "",
            StatusId: "",
            Area: ""
        },
        validationSchema: Yup.object({
            ProductTypeId: Yup.string().required("Please Select Product").nullable(),
            BrandName: Yup.string().required("Please Select Brand").nullable(),
            BrandSeriesName: Yup.string().required("Please Select Series").nullable(),
            BrandModelName: Yup.string().required("Please Select Model").nullable(),
            ModelVariant: (selectedLocationData.ProductTypeName == HelperConstant.ProductTypeName.Phone || selectedLocationData.ProductTypeName == HelperConstant.ProductTypeName.Tablet || selectedLocationData.ProductTypeName == HelperConstant.ProductTypeName.Gaming_Console) && Yup.string().required("Please Select Model Variant").nullable(),
            Name: Yup.string().required("Please Enter Name").nullable(),
            MobileNumber: Yup.string().min(9, "Please Enter Valid Mobile Number").max(10, "Please Enter Valid Mobile Number").required("Please Enter Mobile"),
            Email: Yup.string().required("Please Enter Mobile").nullable(),
            StateId: Yup.string().required("Please Select State").nullable(),
            Area: Yup.string().required("Please Enter the Area Name").nullable(),
            Comments: Yup.string().required("Please Enter the Comments").nullable(),
            StatusId: Yup.string().required("Please Select the Status").nullable(),
        }),

        onSubmit(values) {
            return onUpdateNewLocation(values as any);
        },
    })

    const onUpdateNewLocation = (data: IFindLocation) => {
        data.BrandModelName = data.BrandName;
        data.id = Id;
        setDisabled(true);
        CantFindServicesService.updateLocationList(data.id, data.StatusId, data.Comments).then((res: any) => {
            if (res.status === 200) {
                setEditModel(false);
                requestData(0, "", statusId, "desc", "modified");

            }
            setDisabled(true);
        }).catch((e: string) => {
            console.log(e);
        });
    }


    const getProduct = () => {
        BrandMasterServices.GetAllProductType().then(res => {
            if (res.status === 200) {
                setProduct(res.data);
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }


    const getBrands = (ProductId: number) => {
        BrandMasterServices.GetBrandMasterByProductId(ProductId, HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setBrand(res.data);
                setproductId(ProductId);
            }
        }).catch((e: string) => {
            console.log(e)
        });
    }

    const getModels = (BrandId: number) => {
        // setBrandId(BrandId);
        BrandMasterServices.GetSeriesModelByBrandMasterId(BrandId, HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setModel(res.data);
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const getVariant = (ModelId: number) => {
        BrandMasterServices.GetModelVariantBySeriesModelId(ModelId, HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setVariant(res.data);
                setModelId(ModelId);
            }
        }).catch((e: any) => {
            console.log(e)
        })
    }

    const getStateList = () => {
        BrandMasterServices.GetStateList(HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setStateList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    // const getStatus = () => {
    //     BrandMasterServices.GetStatusByEntityType().then(res => {
    //         if (res.status === 200) {
    //             setStatusList(res.data);
    //         }
    //     }).catch(e => {
    //         console.log(e);
    //     });
    // }

    useEffect(() => {
        getProduct();
        getStateList();
        // getStatus();
        getLocationRequestById();
    }, []);

    const getLocationRequestById = () => {
        LocationService.GetOrderPublicRequestById(Id).then(res => {
            if (res.status === 200) {
                formik.setValues({ ...res.data });
            }
        })
    }

    return (
        <div className="fl_content-style p-2" dir={direction}>
            <Form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Row>
                    <Col xl={6}>
                        <CustomDropdown
                            label={"Product"}
                            id={"ProductTypeId"}
                            name={"ProductTypeId"}
                            value={formik.values.ProductTypeId}
                            data={Product}
                            displayField="Name"
                            valueField="Id"
                            touched={formik.touched.ProductTypeId}
                            error={formik.errors.ProductTypeId}
                            onChange={(e: any) => {
                                formik.handleChange(e);
                                getBrands(e.target.value);
                            }}
                            disabled={true}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="BrandName"
                            label="Brand Name"
                            id={"BrandName"}
                            value={formik.values.BrandName}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.BrandName && formik.errors.BrandName ? true : false}
                            error={formik.errors.BrandName}
                            onChange={formik.handleChange}
                            placeholder={"BrandName"}
                            isMandatory={false}
                            disabled={true}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="BrandModelName"
                            label="Brand Model Name"
                            id={"BrandModelName"}
                            value={formik.values.BrandModelName}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.BrandModelName && formik.errors.BrandModelName ? true : false}
                            error={formik.errors.BrandModelName}
                            onChange={formik.handleChange}
                            placeholder={"BrandModelName"}
                            isMandatory={false}
                            disabled={true}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="BrandSeriesName"
                            label="Brand Series Name"
                            id={"BrandSeriesName"}
                            value={formik.values.BrandSeriesName}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.BrandSeriesName && formik.errors.BrandSeriesName ? true : false}
                            error={formik.errors.BrandSeriesName}
                            onChange={formik.handleChange}
                            placeholder={"BrandSeriesName"}
                            isMandatory={false}
                            disabled={true}
                        />
                    </Col>
                    {(selectedLocationData.ProductTypeName == HelperConstant.ProductTypeName.Phone || selectedLocationData.ProductTypeName == HelperConstant.ProductTypeName.Tablet || selectedLocationData.ProductTypeName == HelperConstant.ProductTypeName.Gaming_Console) &&
                        <Col xl={6}>
                            <CustomTextBox
                                name="ModelVariant"
                                label="Model Variant"
                                id={"ModelVariant"}
                                value={formik.values.ModelVariant}
                                onBlur={formik.handleBlur}
                                invalid={formik.touched.ModelVariant && formik.errors.ModelVariant ? true : false}
                                error={formik.errors.ModelVariant}
                                onChange={formik.handleChange}
                                placeholder={"ModelVariant"}
                                isMandatory={false}
                                disabled={true}
                            />
                        </Col>}
                    <Col xl={6}>
                        <CustomTextBox
                            name="Name"
                            label="Full Name"
                            id={"Name"}
                            value={formik.values.Name}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Name && formik.errors.Name ? true : false}
                            error={formik.errors.Name}
                            onChange={formik.handleChange}
                            placeholder={"Full Name"}
                            isMandatory={false}
                            disabled={true}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomPhoneNumberBox
                            name="MobileNumber"
                            label="Phone Number"
                            id={"MobileNumber"}
                            value={formik.values.MobileNumber}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.MobileNumber && formik.errors.MobileNumber ? true : false}
                            error={formik.errors.MobileNumber}
                            onChange={formik.handleChange}
                            placeholder={"+91 9087654321"}
                            isMandatory={false} disabled={true} />
                    </Col>
                    <Col xl={6}>
                        <CustomEmailBox
                            name="Email"
                            label="Email"
                            id={"Email"}
                            value={formik.values.Email}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Email && formik.errors.Email ? true : false}
                            error={formik.errors.Email}
                            onChange={formik.handleChange}
                            placeholder={"Email"}
                            isMandatory={false} disabled={true} />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="StateName"
                            label="State Name"
                            id={"StateName"}
                            value={formik.values.StateName}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.StateName && formik.errors.StateName ? true : false}
                            error={formik.errors.StateName}
                            onChange={formik.handleChange}
                            placeholder={"StateName"}
                            isMandatory={false}
                            disabled={true}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="Area"
                            label="Area"
                            id={"Area"}
                            value={formik.values.Area}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Area && formik.errors.Area ? true : false}
                            error={formik.errors.Area}
                            onChange={formik.handleChange}
                            placeholder={"Area"}
                            isMandatory={false} disabled={true}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomDropdown
                            label={"Status"}
                            id={"StatusId"}
                            name={"StatusId"}
                            value={formik.values.StatusId}
                            data={statusList}
                            displayField="Name"
                            valueField="Id"
                            touched={formik.touched.StatusId}
                            error={formik.errors.StatusId}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.StatusId && formik.errors.StatusId ? true : false}
                            isMandatory={false} />
                    </Col>
                    <Col xl={6}>
                        <CustomTextArea name="Comments"
                            label="Comments"
                            id={"Comments"}
                            value={formik.values.Comments}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Comments && formik.errors.Comments ? true : false}
                            error={formik.errors.Comments}
                            onChange={formik.handleChange}
                            placeholder={"Comments"}
                            isMandatory={false}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xl={6}></Col>
                    <Col xl={6} className='text-end'>
                        <Button className='btn btn-secondary m-2' type='button' onClick={() => { setEditModel(false); }}>Cancel</Button>
                        <Button className='btn btn-success' type='submit' disabled={disabled}>Update</Button>
                    </Col>
                </Row>
            </Form>
            <Row>
                <CustomToaster message={'Your delay response have been saved.'} color={'text-success'} toast={showToastUpdate} setToast={setShowToastUpdate} />
            </Row>
        </div>
    )
}

export default LocationRequestUAE